interface AliasedName {
    alias: string;
    name: string;
    props: any;
}
  
const knownAttributes: AliasedName[] = [
    {
        alias : 'name',
        name: 'Name',
        props: {
        required: true,
        type: 'text',
        },
    },
    {
        alias : 'phone_number',
        name: 'Phone Number',
        props: {
        pattern: '^\\+?\\d {10,15}$',
        type: 'tel',
        },
    },
    {
        alias : 'email',
        name: 'Email',
        props: {
            required: true,
            type: 'email',
        },
    },
];

export default knownAttributes;


// WEBPACK FOOTER //
// ./src/container/Account/knownAttributes.ts